/**
 * Crée une notification en base et optionnellement envoie un email (Edge send-email / Resend).
 */

function escapeHtml(s) {
  if (s == null) return "";
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export async function sendNotification({
  supabase,
  destinataireId,
  expediteurId,
  type,
  titre,
  message,
  projetId = null,
  sendEmail = false,
  emailDest = null,
}) {
  const safeTitre = escapeHtml(titre);
  const safeMessage = escapeHtml(message);

  const { error: insertError } = await supabase.from("notifications").insert({
    destinataire_id: destinataireId,
    expediteur_id: expediteurId,
    type,
    titre,
    message,
    projet_id: projetId,
    lu: false,
  });

  if (insertError) throw insertError;

  if (sendEmail && emailDest) {
    const { error: fnError } = await supabase.functions.invoke("send-email", {
      body: {
        to: emailDest,
        subject: titre,
        html: `
          <div style="font-family: Georgia, serif; 
            max-width: 600px; margin: 0 auto; 
            padding: 40px; background: #F8F4EE;">
            <h1 style="color: #3D2E20; 
              font-size: 24px; margin-bottom: 16px;">
              ${safeTitre}
            </h1>
            <p style="color: #8B7361; 
              font-size: 15px; line-height: 1.6;">
              ${safeMessage}
            </p>
            <hr style="border: none; 
              border-top: 1px solid #DDD0C0; 
              margin: 32px 0;" />
            <p style="color: #C09A5B; 
              font-size: 12px;">
              YOMA — La plateforme des professionnels 
              de l'espace
            </p>
          </div>
        `,
      },
    });

    if (fnError) throw fnError;
  }
}
